import { useMutation } from '@tanstack/react-query';

import { useAppSelector, useQueryInvalidation } from '@pkg/hooks';

import { callCreateCompetitionTeam, COMPETITION_TEAM_QUERIES } from '@app/client/resources/competitions';
import { mockTeamName } from '@app/pages/FantasyWishlist/hooks';
import { useFantasyMetadataStore, useFantasyTeamsStore } from '@app/store/zustand';

function titleCase(value = '') {
    return value.charAt(0).toLocaleUpperCase() + value.slice(1).toLowerCase();
}

function format(value = '') {
    return value.split(' ').map(titleCase).join(' ');
}

export function useCreateTeam() {
    const { setUserTeam } = useFantasyTeamsStore();
    const invalidateTeamQueries = useQueryInvalidation(COMPETITION_TEAM_QUERIES);
    const username = useAppSelector((state) => state.user.userAccount?.user.username);
    const { currentGame } = useFantasyMetadataStore();

    const name = username ? `${username}'s Team` : format(mockTeamName());

    return useMutation({
        mutationFn: () => callCreateCompetitionTeam({ value: { name } }),
        onSuccess: (data) => {
            if (data?.ok && data.value) {
                if (currentGame?.id) {
                    setUserTeam(data.value);
                }
            }
            invalidateTeamQueries();
        },
    });
}
